module.exports = "data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PGcgZmlsbD0iI0U5MUU2MyI+PGNpcmNsZSBjeD0iMTkiIGN5PSIzMyIgcj0iOSIvPjxwYXRoIGQ9Ik0yNCA2djI3aDRWMTRsMTEgM3YtN3oiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./assets/images/cloze/music.svg
// module id = 3908
// module chunks = 0